// export const lhwpath = `http://localhost:5001`;

export const chawlaispat = `https://chawlaispat.com`

export const lhwpath= `https://www.lohawalla.com`;          
